import React, { useCallback } from 'react';
import Modal from 'react-modal';
import { load, setStopStatusData } from '../../../../store/actions/callCheckLoadsActions/callCheckLoads';
import { CallCheckLoadsSelectors } from '../../../../store/selectors/callCheckLoadsSelectors';

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    minWidth: '250px',
    maxWidth: '320px',
    minHeight: '180px',
    borderRadius: '8px',
    padding: '6px 12px',
    textAlign: 'center',
  },
};

const ConfirmModal = ({
  confirmModalIsOpen,
  setConfirmModalIsOpen,
  rowState,
  page,
  resource,
  dispatch,
  value
}) => {
  const { stateFilterOptions, statePagination } = CallCheckLoadsSelectors();
  
  const closeModal = useCallback(() => {
      setConfirmModalIsOpen(false);
      dispatch(load(resource, page, stateFilterOptions, statePagination));
  }, [dispatch, page, resource, setConfirmModalIsOpen, stateFilterOptions, statePagination]);

  const confirm = useCallback(() => {
      dispatch(setStopStatusData(resource, page, value, rowState));
      setConfirmModalIsOpen(false);
  }, [dispatch, resource, page, value, rowState, setConfirmModalIsOpen]);

  return (
    <Modal
      isOpen={confirmModalIsOpen}
      onRequestClose={closeModal}
      style={customStyles}
    >
      <div>
        <h2 className="confirm_modal_text">You can update the stop status only from the Past Load page</h2>
        <div>
          <button className="confirm-modal-button-confirm"  onClick={confirm}>Confirm</button>
          <button className="confirm-modal-button-cancel" onClick={closeModal}>Cancel</button>
        </div>
      </div>
    </Modal>
  );
};

export default React.memo(ConfirmModal);